export default require("./File-Picker.vue").default;
